var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('p',{staticClass:"primary--text subtitle-1 mb-2 font-weight-bold"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),_vm._t("default")],2),_c('v-divider',{staticClass:"primary"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }